import {
  EntitiesModel as BaseEntitiesModel,
  model,
} from 'mst-collection';

import { TagCollectionModel } from './Tags/TagCollectionModel';
import { UserCollectionModel } from './Viewer/UserCollectionModel';
import { QuestTopicCollectionModel } from './Questionnaire/QuestTopicCollectionModel';
import { TutorialCollectionModel } from './Tutorials/TutorialCollectionModel';
import { TrackCollectionModel } from './Tracks/TrackCollectionModel';
import { NotificationCollectionModel } from './Notifications/NotificationCollectionModel';
import { PaymentMethodCollectionModel } from './Viewer/PaymentMethodCollectionModel';
import { ConversationCollectionModel } from './Chats/ConversationCollectionModel';
import { MessageCollectionModel } from './Chats/MessageCollectionModel';
import { PostCollectionModel } from './Posts/PostCollectionModel';
import { CommentCollectionModel } from './Comments/CommentCollectionModel';
// eslint-disable-next-line max-len
import { SkillLevelQuestionnaireAnswerCollectionModel } from './Questionnaire/SkillLevelQuestionnaireAnswerCollectionModel';
import { CourseCollectionModel } from './Courses/CourseCollectionModel';
import { CourseLessonCollectionModel } from './Courses/CourseLessonCollectionModel';
export class Entities extends BaseEntitiesModel({
  users: UserCollectionModel,
  questTopics: QuestTopicCollectionModel,
  skillLevelQuestionnaireAnswers:
    SkillLevelQuestionnaireAnswerCollectionModel,
  tutorials: TutorialCollectionModel,
  tracks: TrackCollectionModel,
  notifications: NotificationCollectionModel,
  paymentMethods: PaymentMethodCollectionModel,
  conversations: ConversationCollectionModel,
  messages: MessageCollectionModel,
  posts: PostCollectionModel,
  comments: CommentCollectionModel,
  tags: TagCollectionModel,
  courses: CourseCollectionModel,
  lessons: CourseLessonCollectionModel,
}) {}

export const EntitiesModel = model(Entities);
